var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm._.isEmpty(_vm.errors))?_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('response',{attrs:{"items":_vm.errors}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }